
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';

export const usePagePresence = () => {
  const location = useLocation();
  const isGamePage = location.pathname.startsWith('/game/');

  useEffect(() => {
    // Let useGamePresence handle tracking on game pages to include game-specific details
    if (isGamePage) {
      return;
    }

    let channel: any = null;
    
    const setupPresence = async () => {
      try {
        const channelName = 'gamehub-live-activity';
        channel = supabase.channel(channelName);

        channel.subscribe(async (status: string) => {
          if (status === 'SUBSCRIBED') {
            const payload = {
              pageTitle: document.title.split(' | ')[0] || 'Browsing',
              path: location.pathname,
            };
            await channel.track(payload);
          }
        });
      } catch (error) {
        // Silently handle connection errors - don't log for security
      }
    };

    setupPresence();

    return () => {
      if (channel) {
        try {
          supabase.removeChannel(channel);
        } catch (error) {
          // Silently handle cleanup errors
        }
      }
    };
  }, [isGamePage, location.pathname]);
};
